<template>
  <div>
    <div align="left">
      <br />
      <h5 class="h5 text-primary font-weight-bold">Master Benefit Type</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Edit Type</b>
      <br />
      <b-row class="mt-4">
        <b-col sm="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Category"
            label-for="input-1"
          >
            <b-form-select
              v-model="category_id"
              name="category"
              v-validate="'required'"
              data-vv-as="Category"
              class="form-control"
            >
              <template v-slot:first>
                <option value disabled>-- Benefit Category --</option>
              </template>
              <option
                v-for="data in categories"
                :key="data.id"
                :value="data.id"
              >
                {{ data.display }}
              </option>
            </b-form-select>

            <p
              style="width: 100%; font-size: 80%;color: #dc3545;"
            >
              {{ veeErrors.first("category") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col sm="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Type English"
            label-for="input-2"
          >
            <input
              id="input-2"
              v-model="display"
              v-validate="'required'"
              name="display"
              data-vv-as="Type English"
              class="form-control"
              placeholder="Type English"
            />
            <b-form-invalid-feedback
              id="input-display-feedback"
            >{{ veeErrors.first('display') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Type Bahasa"
            label-for="input-2"
          >
            <input
              id="input-2"
              v-model="display_id"
              v-validate="'required'"
              name="display_id"
              data-vv-as="Type Bahasa"
              class="form-control"
              placeholder="Type Bahasa"
            />
            <b-form-invalid-feedback
              id="input-display_id-feedback"
            >{{ veeErrors.first('display_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <div class="form-group required font-weight-bold">
        <label class="control-label"></label>
        Required
      </div>
      <b-row class="text-right">
        <b-col>
          <b-button variant="primary" :disabled="loading" @click="put()" class="mr-3" size="lg">Save</b-button>
          <router-link :to="{name: 'BenefitType'}">
            <b-button size="lg" variant="outline-secondary">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      categories: [],
      category_id: "",
      display: "",
      display_id: "",
    };
  },
  methods: {
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Benefit Type!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              formData.append("display", this.display);
              formData.append("display_id", this.display_id);
              formData.append("category_id", this.category_id);
              this.$store
                .dispatch("BenefitTypeModule/putBenefitType", {
                  id: this.$route.params.id,
                  data: formData
                })
                .then(response => {
                  this.loading = false;
                  this.$router.push({ name: "BenefitType" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                })
                .catch(error => {
                  this.loading = false;
                  this.serverError = error.response.data;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(error);
                });
            } else {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: this.$validator.errors.all(),
                showConfirmButton: false,
                timer: 1500
              });
            }
          });
        }
      });
    }
  },
  beforeMount() {
    this.$store
      .dispatch("BenefitCategoryModule/getBenefitCategories")
      .then((response) => {
        this.categories = response.data.data.categorys;
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.categories = [];
      });

    this.$store
        .dispatch("BenefitTypeModule/getBenefitTypes")
        .then(response => {
          const data = response.data.data.type_benefits
          if(data) {
            const id = this.$route.params.id;
            const item = data.find(type => type.id == id);
            this.category_id = item.type_category_benefit.id;
            this.display = item.display;
            this.display_id = item.display_id;
          } else {
            this.$swal({
              type: "error",
              title: "Oops...",
              text: "Your edit data could not be fetched",
              showConfirmButton: false,
              timer: 1500
            });  
          }
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: "Your edit data could not be fetched",
            showConfirmButton: false,
            timer: 1500
          });
        });
  },
};
</script>

<style>
</style>
